module.exports = __webpack_public_path__ + "static/Rebel-com-large-white-94737f9a7332c5b323cb1d915097be6d.png";